import {SurveyDefinitionModel} from "data/models/survey";
// import {BusinessTypeTitle} from "components/Survey/survey-sections-rendering-components/BusinessInfoTitles";
import {ChoiceValue} from "data/models/survey/choice-base";
import {choiceValueMap} from "helpers/choice-values";
import {
  BusinessDescriptionParagraph,
  BusinessDescriptionTitle
} from "components/Survey/survey-sections-rendering-components/BusinessInfoTitles";

export const BUSINESS_TYPE_CHOICES: ChoiceValue[] = [
  {
    key: "service",
    value: "service",
  },
  {
    key: "product",
    value: "product",
  },
  {
    key: "location",
    value: "location",
  },
  {
    key: "event",
    value: "event",
  },
  {
    key: "digital",
    value: "digital",
  },
];
export const BUSINESS_TYPE_CHOICES_MAP = choiceValueMap(BUSINESS_TYPE_CHOICES);

export const BUSINESS_INFO_SURVEY: SurveyDefinitionModel = {
  id: "business-info",
  surveyQuestions: [
    {
      id: "business-name",
      title: "What is the name of your business, product, or service?",
      description: null,
      kind: "input",
      maxScreenWidth: "md",
      required: true,
      backButtonText: null,
      nextButtonText: null,
      options: {
        inputType: 'text',
        linesHeight: 1,
        placeholder: "Business Name",
        textAlignment: "center",
        paragraphs: [],
      },
    }, {
      id: "user-login",
      title: "",
      description: null,
      kind: "user-login",
      maxScreenWidth: "md",
      required: true,
      backButtonText: null,
      nextButtonText: null,
      options: {
      },
    },
    // {
    //   id: "business-type",
    //   title: BusinessTypeTitle,
    //   description: "Select all that apply.",
    //   kind: "multi-choice-select",
    //   maxScreenWidth: "md",
    //   required: true,
    //   backButtonText: null,
    //   nextButtonText: null,
    //   options: {
    //     sorted: true,
    //     otherInputBox: true,
    //     enablingQuestion: null,
    //     choices: BUSINESS_TYPE_CHOICES,
    //   },
    // },
    {
      id: "business-description",
      title: BusinessDescriptionTitle,
      description: "In just a few words, what is your product, service, program, or company?",
      kind: "input",
      maxScreenWidth: "md",
      required: true,
      backButtonText: null,
      nextButtonText: null,
      options: {
        inputType: 'text',
        linesHeight: 1,
        placeholder: "Description",
        textAlignment: "center",
        paragraphs: [
          BusinessDescriptionParagraph,
        ],
      },
    }
  ],
};
